import React, { useCallback } from 'react';
import { Textarea } from 'components/ui/textarea';

interface OpenEndedPlayerProps {
  value: string;
  onChange: (value: string) => void;
  maxWords?: number;
  rubric?: string;
  disabled?: boolean;
  placeholder?: string;
}

/** Extended text response with an optional word-count limit. */
export function OpenEndedPlayer({
  value,
  onChange,
  maxWords,
  rubric,
  disabled = false,
  placeholder = 'Type your answer here...',
}: OpenEndedPlayerProps) {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      onChange(e.target.value);
    },
    [onChange],
  );

  // Count words
  const wordCount = value.trim() ? value.trim().split(/\s+/).length : 0;
  const isOverLimit = maxWords && wordCount > maxWords;

  return (
    <div className="open-ended-player">
      {rubric && (
        <div className="mb-3 rounded-lg border border-border bg-muted/40 p-3">
          <p className="text-xs font-semibold text-foreground">Grading Rubric:</p>
          <p className="mt-1 text-sm text-muted-foreground">{rubric}</p>
        </div>
      )}

      <Textarea
        value={value}
        onChange={handleChange}
        disabled={disabled}
        placeholder={placeholder}
        rows={6}
        className="text-sm"
      />

      <div className="mt-2 flex items-center justify-between text-xs text-gray-500">
        <span>
          {maxWords ? (
            <span className={isOverLimit ? 'text-red-500' : ''}>
              {wordCount} / {maxWords} words
            </span>
          ) : (
            <span>{wordCount} words</span>
          )}
        </span>
        {isOverLimit && (
          <span className="text-red-500">Word limit exceeded</span>
        )}
      </div>
    </div>
  );
}

export default OpenEndedPlayer;
